module.exports = __webpack_public_path__ + "static/img/no-video.fe067b03.png";